import React from 'react';
import LandingPage from './LandingPage';

const MobileBartending = () => {
  return <LandingPage />;
};

export default MobileBartending;